module.exports = __webpack_public_path__ + "static/media/persistence-of-dreams.21117a2f.jpg";